import axios from 'axios';

import { Constants } from '@/constants';

export interface ClaimConfirmationRecipient {
  claimId: number;
  businessId: number;
  businessType: 'venue' | 'brand';
  businessName: string;
  userId: number;
  recipientName: string;
  email: string;
  latest?: { status: string; updated_at: string; source: string } | null;
}

export const getClaimConfirmation = async (claimId: number) =>
  (
    await axios.get<{ data: ClaimConfirmationRecipient }>(
      `${Constants.apiPath}/claim-confirmations/claim/${claimId}`
    )
  ).data.data;

export const getUserClaimConfirmations = async (userId: number) =>
  (
    await axios.get<{ data: ClaimConfirmationRecipient[] }>(
      `${Constants.apiPath}/claim-confirmations/user/${userId}`
    )
  ).data.data;

export const sendClaimConfirmation = async (claimId: number, userId?: number) =>
  (
    await axios.post(
      userId
        ? `${Constants.apiPath}/claim-confirmations/user/${userId}/claim/${claimId}`
        : `${Constants.apiPath}/claim-confirmations/claim/${claimId}`
    )
  ).data;
